import {
  CreatePostDataDocument,
  CreatePostDataMutation,
  CreatePostDataMutationVariables,
} from "../../GeneratedGraphQL";

import { defaultOrganisation } from "../organisation";
import { defaultPostData } from "./postData";
import { GraphQLError } from "graphql";
import { MockedResponse } from "@apollo/client/testing";

const defaultVariables: CreatePostDataMutationVariables = {
  input: {
    fileExtension: "csv",
    organisationId: defaultOrganisation._id,
    reservationId: "12345",
  },
};

export const createPostDataRequestSuccess: MockedResponse<CreatePostDataMutation> =
  {
    request: {
      query: CreatePostDataDocument,
      variables: defaultVariables,
    },
    result: {
      data: {
        createParticipantUploadPresignedUrl: JSON.stringify(defaultPostData),
      },
    },
  };

export const createPostDataRequestFailure: MockedResponse<CreatePostDataMutation> =
  {
    request: {
      query: CreatePostDataDocument,
      variables: defaultVariables,
    },
    result: {
      errors: [new GraphQLError("oh no")],
    },
  };
